import { driver, PopoverDOM } from 'driver.js';
import { DefaultTheme } from 'styled-components/macro';
import { TourConfig } from './tour.types';
import { renderFooter } from './ui/render-footer-buttons';

import { waitForElement } from './tour.helpers';

export const runTour = async (
  tour: TourConfig,
  theme: DefaultTheme,
  onComplete?: () => void,
  onDestroy?: () => void
) => {
  const stepsWithElements = await Promise.all(
    tour.steps.map(async (step) => {
      const selector = `[data-tour="${step.target}"]`;
      await waitForElement(selector);

      return {
        element: selector,
        popover: {
          title: step.title,
          description: step.description,
          side: step.side ?? 'bottom',
          align: step.align ?? 'center',
          onPopoverRender: (popover: PopoverDOM) => {
            popover.footer.replaceWith(renderFooter(theme, drv, tour));
          },
        },
      };
    })
  );

  const drv = driver({
    animate: true,
    steps: stepsWithElements,
    popoverOffset: 16,
    disableActiveInteraction: true,
    // onDestroy зовём при ЛЮБОМ завершении (в т.ч. закрытие крестиком,
    // уход со страницы — см. TourRouteSync) — им сбрасывается activeTourId
    // в контексте. onComplete — только при реальном прохождении до
    // последнего шага, им помечаем тур просмотренным на бэке.
    onDestroyed: (_, state) => {
      onDestroy?.();

      if (state.element === stepsWithElements.at(-1)?.element) {
        onComplete?.();
      }
    },
    overlayClickBehavior: () => {
      return null;
    },
    onCloseClick: async () => {
      onComplete?.();
      drv.destroy();
    },
    onHighlighted: () => {
      const state = drv.getState();
      const currentStepIndex = state.activeIndex;

      if (
        currentStepIndex !== -1 &&
        tour.steps[currentStepIndex]?.onStepEnter
      ) {
        tour.steps[currentStepIndex].onStepEnter?.();
      }

      setTimeout(() => {
        drv.refresh?.();
      }, 0);
    },
  });

  drv.drive();

  return {
    destroy: () => drv.destroy(),
  };
};
